import * as React from "react";
import { cn } from "@/lib/utils";
import { fieldControlClass } from "@/components/ui/input";

/** Native select with shared field chrome — plan/27 (Radix Select later if needed). */
export const Select = React.forwardRef<
  HTMLSelectElement,
  React.ComponentProps<"select">
>(({ className, children, ...props }, ref) => {
  return (
    <select
      className={cn(fieldControlClass, "pr-8", className)}
      ref={ref}
      {...props}
    >
      {children}
    </select>
  );
});
Select.displayName = "Select";
